import OpenFolder from 'components/Icons/OpenFolder';
import Studio from 'components/Icons/Studio';
import { getAccountName } from 'constants/integrations';
import Immutable from 'immutable';
import React, { ReactElement, useEffect, useState } from 'react';
import { BreadcrumbItem } from 'records/BreadcrumbItem';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import { useTranslator } from '@bluebeam/react-i18n';
import BreadcrumbsDropdown from './BreadcrumbsDropdownOfAppState';

interface Props extends WithAppStoreProps {
  providerType: string;
}

const BreadcrumbsOfAppState: React.FC<Props> = (props: Props) => {
  const { providerType, actions, appStore } = props;
  const [providerName, setProviderName] = useState('');
  const [lastBreadcrumb, setLastBreadcrumb] = useState<BreadcrumbItem>();
  const [nextToLastBreadcrumb, setNextToLastBreadcrumb] =
    useState<BreadcrumbItem>();
  const [remainingBreadcrumbs, setRemainingBreadcrumbs] = useState(
    Immutable.List<BreadcrumbItem>()
  );
  const { breadcrumbsItems } = appStore.state;
  const { translate } = useTranslator(['integrationsPage']);

  useEffect(() => {
    const breadcrumbList = Immutable.List(breadcrumbsItems.folders);
    const lastBC = breadcrumbList.get(-1);
    const nextToLastBC = breadcrumbList.get(-2);
    const remainingBC = breadcrumbList.slice(0, -2);
    setLastBreadcrumb(lastBC);
    setNextToLastBreadcrumb(nextToLastBC);
    setRemainingBreadcrumbs(remainingBC);

    const acct = getAccountName(providerType);
    const acctName =
      acct === 'Connection'
        ? translate('integrationsPage:default.title')
        : acct;
    setProviderName(acctName);
  }, [breadcrumbsItems, providerType]);

  const Caret = () => <div className="mr2 font-size-4">{'>'}</div>;

  const Icon = (): ReactElement => {
    switch (providerType) {
      case 'studio':
        return <Studio width="18px" height="18px" />;
      default:
        return <OpenFolder />;
    }
  };

  const updatedSelectedFolder = async (item: BreadcrumbItem): Promise<void> => {
    if (providerType === 'studio') {
      actions.setStudioFolderName(item.label);
      actions.getStudioProjectFolder(item.driveId, item.folderId);
    } else {
      actions.loadIntegrationsFolder(item.driveId, item.folderId);
      actions.setFolderSelectCurrentId(item.folderId);
    }
    actions.setFolderSelectCurrentId(item.folderId);
  };

  const goToRootView = async (): Promise<void> => {
    if (providerType === 'studio') {
      await actions.resetStudioView();
    } else {
      await actions.resetIntegrationsView();
    }
    await actions.resetBreadcrumbs();
  };

  return (
    <div className="flex row hrem-2 items-center">
      <div className="color-primary">
        <Icon />
      </div>

      <div
        className="color-primary underline  cursor-pointer font-size-4 mx2"
        onClick={() => goToRootView()}
      >
        {providerName}
      </div>
      {remainingBreadcrumbs.size > 0 && <Caret />}
      {remainingBreadcrumbs.size > 0 && (
        <div className="mr2">
          <BreadcrumbsDropdown
            breadcrumbs={remainingBreadcrumbs}
            handleClick={updatedSelectedFolder}
          />
        </div>
      )}
      {nextToLastBreadcrumb && <Caret />}
      {nextToLastBreadcrumb && (
        <div
          className="color-primary underline font-size-4 cursor-pointer mr2"
          onClick={() => updatedSelectedFolder(nextToLastBreadcrumb)}
        >
          {nextToLastBreadcrumb.label}
        </div>
      )}
      {lastBreadcrumb && <Caret />}
      {lastBreadcrumb && (
        <div className="font-size-4 mr2">{lastBreadcrumb.label}</div>
      )}
    </div>
  );
};

export default withAppStore<Props>(BreadcrumbsOfAppState);
